var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Autocomplete, Button, Divider, TextField, Typography, useMediaQuery } from "@mui/material";
import { styled } from '@mui/material/styles';
import dayjs from "dayjs";
import { t } from 'i18next';
import { useEffect, useState } from "react";
import { Config } from "../../../api/config";
import { AppointmentServiceAdvisorList, RepairTypeList, StatusList, USER_PROFILE_DATA, VehicleList, getFinalInspectorListUrl } from "../../../api/url";
import { CrossIcon } from "../../../assets/images";
import MuiAccordion from "../../../components/atoms/accordion";
import { MuiBox } from "../../../components/atoms/boxComponent";
import { MuiButton } from "../../../components/atoms/buttonComponent";
import { MuiDatePicker } from "../../../components/atoms/datePicker";
import { MuiIconButton } from "../../../components/atoms/iconButtonComponent";
import { MuiSelectComponent } from "../../../components/atoms/muiSelectComponent";
import { MuiStack } from "../../../components/atoms/stackComponent";
import Loader from "../../../components/molecules/loader";
import CheckboxFilters from "../../../components/templates/filters/checkboxFilters";
import DateFilters from "../../../components/templates/filters/dateFilters";
import { EFilterParent, ESystemName, FilterComponentWidth, LOCAL_STORAGE_KEYS } from "../../../constants";
import { setIsLeftMenuOpen, showLoader, showNotification } from "../../../redux/commonSlice";
import { getByIdAPI, getListAPI, setState } from "../../../redux/crudSlice";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { getLocalStorageItem, setLocalStorageItem } from "../../../utils/storageHelper";
import { maxDays, validateFilterDuration } from "../../../utils/utils";
import { Close } from "@mui/icons-material";
var ResetButton = styled(MuiButton)(function (_ref) {
    var theme = _ref.theme;
    return {
        color: "#6A7682",
        borderColor: "#DEE4EB"
    };
});
var Label = function (_ref2) {
    var children = _ref2.children;
    return /*#__PURE__*/ React.createElement(Typography, {
        color: 'text.tertiary',
        fontSize: "sm",
        fontWeight: "medium",
        mb: 0.5
    }, children);
};
export var formateDdMm = function (item) {
    if (item < 10) {
        return "0".concat(item);
    }
    else {
        return item;
    }
};
var dateFormate = function (date) {
    var objectDate = new Date(date);
    var d = objectDate.getDate();
    var m = objectDate.getMonth();
    var y = objectDate.getFullYear();
    var month = formateDdMm(m + 1);
    var dd = formateDdMm(d);
    return "".concat(y, "-").concat(month, "-").concat(dd);
};
var tabListInfo = [{
        id: "1",
        name: "Date"
    }, {
        id: "2",
        name: "Mode"
    }, {
        id: "3",
        name: "Status"
    }, {
        id: "4",
        name: "Service type"
    }, {
        id: "5",
        name: "Brand"
    }];
export var Filters = function (props) {
    var _userData$data, _userData$data2, _userData$data3, _serviceAdvisors$, _filterPickList$data, _commonState$selected3, _filterPickList$data2, _filterPickList$data3;
    var handleOnClose = props.handleOnClose, parent = props.parent, systemName = props.systemName, selectedValue = props.selectedValue;
    var dispatch = useAppDispatch();
    var userData = getLocalStorageItem(USER_PROFILE_DATA);
    var loader = useAppSelector(function (state) { return state.common.isLoader; });
    var commonState = useAppSelector(function (state) { return state.common; });
    var isSmallScreen = useMediaQuery(function (theme) { return theme.breakpoints.up("xs"); });
    var _a = useAppSelector(function (state) { return state.crud; }), filterPickList = _a.filterPickList, filterValue = _a.filterValue, repairTypeList = _a.repairTypeList, advisorList = _a.advisorList;
    var selectedDesignation = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_DESIGNATION);
    var statusList = getLocalStorageItem(LOCAL_STORAGE_KEYS.STATUS_LIST);
    var vehicleList = getLocalStorageItem(LOCAL_STORAGE_KEYS.VEHICLE_LIST);
    var MaxDateRange = getLocalStorageItem(LOCAL_STORAGE_KEYS.DATE_FILTER_RESTRICTION);
    var selectedBranch = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_BRANCH);
    var serviceAdvisors = [{
            advisorName: "".concat(userData === null || userData === void 0 || (_userData$data = userData.data) === null || _userData$data === void 0 ? void 0 : _userData$data.GivenName, " ").concat(userData === null || userData === void 0 || (_userData$data2 = userData.data) === null || _userData$data2 === void 0 ? void 0 : _userData$data2.FamilyName),
            IdentityId: userData === null || userData === void 0 || (_userData$data3 = userData.data) === null || _userData$data3 === void 0 ? void 0 : _userData$data3.IdentityId
        }];
    var branchList = [{
            OrganizationName: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationName,
            OrganizationId: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId
        }];
    var _b = useState([]), modes = _b[0], setModes = _b[1];
    var _c = useState(""), selectedServiceType = _c[0], setSelectedSeviceType = _c[1];
    var _d = useState([]), selectedStatus = _d[0], setSelectedStatus = _d[1];
    var _e = useState(""), modelCode = _e[0], setModelCode = _e[1]; //reffer as brand
    var _f = useState(), startDocDate = _f[0], setStartDocDate = _f[1];
    var _g = useState(), endDocDate = _g[0], setEndDocDate = _g[1];
    var _h = useState(false), endDateError = _h[0], setEndDateError = _h[1];
    var _j = useState(''), branch = _j[0], setBranch = _j[1];
    var _k = useState(), advisor = _k[0], setSelectedAdvisor = _k[1];
    var _l = useState(tabListInfo), tabList = _l[0], setTabList = _l[1];
    var _m = useState([]), advisorListState = _m[0], setAdvisorListState = _m[1];
    var _o = useState({
        status: [],
        vehicleList: [],
        serviceType: []
    }), filterList = _o[0], setFilterList = _o[1];
    useEffect(function () {
        fetchAlllistData();
    }, []);
    var fetchAlllistData = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, repairType, vehicleList, statusList;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, dispatch(showLoader({
                        isLoaderOpen: true
                    }))];
                case 1:
                    _b.sent();
                    return [4 /*yield*/, Promise.all([GetRepairType(), GetVehicleList(), GetStatusList()])];
                case 2:
                    _a = _b.sent(), repairType = _a[0], vehicleList = _a[1], statusList = _a[2];
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: false
                        }))];
                case 3:
                    _b.sent();
                    setFilterList(_objectSpread(_objectSpread({}, filterList), {}, {
                        status: statusList,
                        vehicleList: vehicleList,
                        serviceType: repairType
                    }));
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        var _filterValue$Status;
        setModes(filterValue === null || filterValue === void 0 ? void 0 : filterValue.Mode);
        console.log("filterValue?.Status", filterValue);
        setSelectedStatus((_filterValue$Status = filterValue === null || filterValue === void 0 ? void 0 : filterValue.Status) !== null && _filterValue$Status !== void 0 ? _filterValue$Status : []);
        setModelCode(filterValue === null || filterValue === void 0 ? void 0 : filterValue.ModelId);
        setSelectedSeviceType(filterValue === null || filterValue === void 0 ? void 0 : filterValue.ServiceTypeId);
        setSelectedAdvisor(filterValue === null || filterValue === void 0 ? void 0 : filterValue.ServiceAdvisorId);
        setBranch(filterValue === null || filterValue === void 0 ? void 0 : filterValue.BranchId);
        if (filterValue !== null && filterValue !== void 0 && filterValue.StartDocDate) {
            setStartDocDate(dayjs(filterValue === null || filterValue === void 0 ? void 0 : filterValue.StartDocDate));
        }
        if (filterValue !== null && filterValue !== void 0 && filterValue.EndDocDate) {
            setEndDocDate(dayjs(filterValue === null || filterValue === void 0 ? void 0 : filterValue.EndDocDate));
        }
        if (filterValue !== null && filterValue !== void 0 && filterValue.BranchId) {
            GetServiceAdvisor(filterValue === null || filterValue === void 0 ? void 0 : filterValue.BranchId);
        }
    }, [filterValue]);
    useEffect(function () {
        var _commonState$selected, _commonState$selected2;
        if ((_commonState$selected = commonState.selectedDesignation) !== null && _commonState$selected !== void 0 && _commonState$selected.DesignationName && ((_commonState$selected2 = commonState.selectedDesignation) === null || _commonState$selected2 === void 0 ? void 0 : _commonState$selected2.DesignationName) === "Final Inspector") {
            var updatedTabList = __spreadArray([], tabList, true).filter(function (item) { return item.name !== "Status"; });
            setTabList(updatedTabList);
        }
    }, [commonState.selectedDesignation]);
    var GetRepairType = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _repairTypeList$data, _repairType$payload, _repairType$payload2, request, repairType, _repairType$payload3, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 4, , 5]);
                    if (!!((repairTypeList === null || repairTypeList === void 0 || (_repairTypeList$data = repairTypeList.data) === null || _repairTypeList$data === void 0 ? void 0 : _repairTypeList$data.length) > 0)) return [3 /*break*/, 2];
                    request = {
                        ModuleEntityId: systemName,
                        OrganizationId: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId
                    };
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "repairTypeList",
                            url: RepairTypeList,
                            request: request
                        }))];
                case 1:
                    repairType = _a.sent();
                    if ((repairType === null || repairType === void 0 || (_repairType$payload = repairType.payload) === null || _repairType$payload === void 0 || (_repairType$payload = _repairType$payload.value) === null || _repairType$payload === void 0 ? void 0 : _repairType$payload.statusCode) == 200 || repairType !== null && repairType !== void 0 && (_repairType$payload2 = repairType.payload) !== null && _repairType$payload2 !== void 0 && (_repairType$payload2 = _repairType$payload2.value) !== null && _repairType$payload2 !== void 0 && _repairType$payload2.success) {
                        return [2 /*return*/, repairType === null || repairType === void 0 || (_repairType$payload3 = repairType.payload) === null || _repairType$payload3 === void 0 || (_repairType$payload3 = _repairType$payload3.value) === null || _repairType$payload3 === void 0 ? void 0 : _repairType$payload3.data];
                    }
                    return [3 /*break*/, 3];
                case 2: return [2 /*return*/, repairTypeList === null || repairTypeList === void 0 ? void 0 : repairTypeList.data];
                case 3: return [3 /*break*/, 5];
                case 4:
                    e_1 = _a.sent();
                    console.error("Error fetching repair types:", e_1);
                    return [2 /*return*/, []];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var GetVehicleList = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _vehicleListResponse$, _vehicleListResponse$2, request, vehicleListResponse, _vehicleListResponse$3, vehilce, finalVehicleList, updatedList, error_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 4, , 5]);
                    if (!(vehicleList && vehicleList[selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId] && vehicleList[selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId].length > 0)) return [3 /*break*/, 1];
                    return [2 /*return*/, vehicleList[selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId]];
                case 1:
                    request = {
                        SystemName: "Product",
                        OrganizationId: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId
                    };
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "vehicleList",
                            url: VehicleList,
                            request: request
                        }))];
                case 2:
                    vehicleListResponse = _b.sent();
                    if ((vehicleListResponse === null || vehicleListResponse === void 0 || (_vehicleListResponse$ = vehicleListResponse.payload) === null || _vehicleListResponse$ === void 0 || (_vehicleListResponse$ = _vehicleListResponse$.value) === null || _vehicleListResponse$ === void 0 ? void 0 : _vehicleListResponse$.statusCode) == 200 && vehicleListResponse !== null && vehicleListResponse !== void 0 && (_vehicleListResponse$2 = vehicleListResponse.payload) !== null && _vehicleListResponse$2 !== void 0 && (_vehicleListResponse$2 = _vehicleListResponse$2.value) !== null && _vehicleListResponse$2 !== void 0 && _vehicleListResponse$2.success) {
                        vehilce = vehicleListResponse === null || vehicleListResponse === void 0 || (_vehicleListResponse$3 = vehicleListResponse.payload) === null || _vehicleListResponse$3 === void 0 || (_vehicleListResponse$3 = _vehicleListResponse$3.value) === null || _vehicleListResponse$3 === void 0 ? void 0 : _vehicleListResponse$3.data;
                        finalVehicleList = vehilce === null || vehilce === void 0 ? void 0 : vehilce.map(function (item) { return _objectSpread(_objectSpread({}, item), {}, {
                            vehicleName: item.Name && item.SkuCode ? "".concat(item === null || item === void 0 ? void 0 : item.Name, " (").concat(item === null || item === void 0 ? void 0 : item.SkuCode, ")") : null
                        }); });
                        updatedList = _objectSpread(_objectSpread({}, vehicleList), {}, (_a = {},
                            _a[selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId] = finalVehicleList,
                            _a));
                        setLocalStorageItem(LOCAL_STORAGE_KEYS.VEHICLE_LIST, updatedList);
                        return [2 /*return*/, finalVehicleList];
                    }
                    _b.label = 3;
                case 3: return [3 /*break*/, 5];
                case 4:
                    error_1 = _b.sent();
                    console.error("Error fetching vehicle types:", error_1);
                    return [2 /*return*/, []];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var GetStatusList = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _response, _response2, response, request, request, request, _response5, updatedList, _response3, _response4, error_2;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 9, , 10]);
                    if (!(statusList && statusList[systemName] && statusList[systemName].length > 0)) return [3 /*break*/, 1];
                    return [2 /*return*/, statusList[systemName]];
                case 1:
                    response = null;
                    if (!(systemName === ESystemName.Jobcard && selectedDesignation.Name !== "FinalInspector")) return [3 /*break*/, 3];
                    request = {
                        SystemName: systemName
                    };
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: "statusList",
                            url: "".concat(Config.baseURL, "JobCard/BySystemName"),
                            request: request
                        }))];
                case 2:
                    response = _c.sent();
                    return [3 /*break*/, 7];
                case 3:
                    if (!(parent === "Final Inspection" || selectedDesignation.Name === "FinalInspector")) return [3 /*break*/, 5];
                    request = {
                        SystemName: ESystemName.FinalInspection
                    };
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: "statusList",
                            url: "".concat(Config.baseURL, "JobCard/BySystemName"),
                            request: request
                        }))];
                case 4:
                    response = _c.sent();
                    return [3 /*break*/, 7];
                case 5:
                    request = {
                        SystemName: systemName
                    };
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: "statusList",
                            url: StatusList,
                            request: request
                        }))];
                case 6:
                    response = _c.sent();
                    _c.label = 7;
                case 7:
                    if (((_response = response) === null || _response === void 0 || (_response = _response.payload) === null || _response === void 0 || (_response = _response.value) === null || _response === void 0 ? void 0 : _response.statusCode) == 200 && (_response2 = response) !== null && _response2 !== void 0 && (_response2 = _response2.payload) !== null && _response2 !== void 0 && (_response2 = _response2.value) !== null && _response2 !== void 0 && _response2.success) {
                        updatedList = null;
                        if (parent === "Final Inspection" || selectedDesignation.Name === "FinalInspector") {
                            updatedList = _objectSpread(_objectSpread({}, statusList), {}, (_a = {},
                                _a[ESystemName.FinalInspection] = (_response3 = response) === null || _response3 === void 0 || (_response3 = _response3.payload) === null || _response3 === void 0 || (_response3 = _response3.value) === null || _response3 === void 0 ? void 0 : _response3.data,
                                _a));
                        }
                        else {
                            updatedList = _objectSpread(_objectSpread({}, statusList), {}, (_b = {},
                                _b[systemName] = (_response4 = response) === null || _response4 === void 0 || (_response4 = _response4.payload) === null || _response4 === void 0 || (_response4 = _response4.value) === null || _response4 === void 0 ? void 0 : _response4.data,
                                _b));
                        }
                        setLocalStorageItem(LOCAL_STORAGE_KEYS.STATUS_LIST, updatedList);
                        return [2 /*return*/, (_response5 = response) === null || _response5 === void 0 || (_response5 = _response5.payload) === null || _response5 === void 0 || (_response5 = _response5.value) === null || _response5 === void 0 ? void 0 : _response5.data];
                    }
                    _c.label = 8;
                case 8: return [3 /*break*/, 10];
                case 9:
                    error_2 = _c.sent();
                    console.error("Error fetching vehicle types:", error_2);
                    return [2 /*return*/, []];
                case 10: return [2 /*return*/];
            }
        });
    }); };
    var GetServiceAdvisor = function (branchId) { return __awaiter(void 0, void 0, void 0, function () {
        var _advisorList$data, _advisorListResponse, _advisorListResponse2, request, advisorListResponse, _advisorListResponse3, advisor_1, FinalAdvisorList, FinalAdvisorList, _advisorList$data2, error_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 9, , 10]);
                    if (!!(selectedValue == "My Appointments" || selectedValue == "My job card")) return [3 /*break*/, 8];
                    if (!!((advisorList === null || advisorList === void 0 || (_advisorList$data = advisorList.data) === null || _advisorList$data === void 0 ? void 0 : _advisorList$data.length) > 0)) return [3 /*break*/, 7];
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: true
                        }))];
                case 1:
                    _a.sent();
                    request = {
                        BranchId: branchId
                    };
                    advisorListResponse = null;
                    if (!(selectedDesignation.Name === "FinalInspector")) return [3 /*break*/, 3];
                    request = {
                        WorkingOrganizationId: branchId
                    };
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: "finalInspectorList",
                            url: getFinalInspectorListUrl,
                            request: request
                        }))];
                case 2:
                    advisorListResponse = _a.sent();
                    return [3 /*break*/, 5];
                case 3:
                    request = {
                        BranchId: branchId
                    };
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: "advisorList",
                            url: AppointmentServiceAdvisorList,
                            request: request
                        }))];
                case 4:
                    advisorListResponse = _a.sent();
                    _a.label = 5;
                case 5: return [4 /*yield*/, dispatch(showLoader({
                        isLoaderOpen: false
                    }))];
                case 6:
                    _a.sent();
                    if (((_advisorListResponse = advisorListResponse) === null || _advisorListResponse === void 0 || (_advisorListResponse = _advisorListResponse.payload) === null || _advisorListResponse === void 0 || (_advisorListResponse = _advisorListResponse.value) === null || _advisorListResponse === void 0 ? void 0 : _advisorListResponse.statusCode) == 200 && (_advisorListResponse2 = advisorListResponse) !== null && _advisorListResponse2 !== void 0 && (_advisorListResponse2 = _advisorListResponse2.payload) !== null && _advisorListResponse2 !== void 0 && (_advisorListResponse2 = _advisorListResponse2.value) !== null && _advisorListResponse2 !== void 0 && _advisorListResponse2.success) {
                        advisor_1 = (_advisorListResponse3 = advisorListResponse) === null || _advisorListResponse3 === void 0 || (_advisorListResponse3 = _advisorListResponse3.payload) === null || _advisorListResponse3 === void 0 || (_advisorListResponse3 = _advisorListResponse3.value) === null || _advisorListResponse3 === void 0 ? void 0 : _advisorListResponse3.data;
                        FinalAdvisorList = [];
                        if (selectedDesignation.Name === "FinalInspector") {
                            FinalAdvisorList = advisor_1 === null || advisor_1 === void 0 ? void 0 : advisor_1.map(function (item) { return _objectSpread(_objectSpread({}, item), {}, {
                                advisorName: item.FirstName && item.LastName ? "".concat(item === null || item === void 0 ? void 0 : item.FirstName, " ").concat(item === null || item === void 0 ? void 0 : item.LastName) : null,
                                IdentityId: item.IdentityId ? item.IdentityId : item.EmployeeId
                            }); });
                        }
                        else {
                            FinalAdvisorList = advisor_1 === null || advisor_1 === void 0 ? void 0 : advisor_1.map(function (item) { return _objectSpread(_objectSpread({}, item), {}, {
                                advisorName: item.GivenName && item.FamilyName ? "".concat(item === null || item === void 0 ? void 0 : item.GivenName, " ").concat(item === null || item === void 0 ? void 0 : item.FamilyName) : null
                            }); });
                        }
                        setAdvisorListState(FinalAdvisorList);
                    }
                    return [3 /*break*/, 8];
                case 7:
                    FinalAdvisorList = [];
                    if (selectedDesignation.Name === "FinalInspector") {
                        FinalAdvisorList = advisor === null || advisor === void 0 ? void 0 : advisor.map(function (item) { return _objectSpread(_objectSpread({}, item), {}, {
                            advisorName: item.FirstName && item.LastName ? "".concat(item === null || item === void 0 ? void 0 : item.FirstName, " ").concat(item === null || item === void 0 ? void 0 : item.LastName) : null,
                            IdentityId: item.IdentityId ? item.IdentityId : item.EmployeeId
                        }); });
                    }
                    else {
                        FinalAdvisorList = advisorList === null || advisorList === void 0 || (_advisorList$data2 = advisorList.data) === null || _advisorList$data2 === void 0 ? void 0 : _advisorList$data2.map(function (item) { return _objectSpread(_objectSpread({}, item), {}, {
                            advisorName: item.GivenName && item.FamilyName ? "".concat(item === null || item === void 0 ? void 0 : item.GivenName, " ").concat(item === null || item === void 0 ? void 0 : item.FamilyName) : null
                        }); });
                    }
                    setAdvisorListState(FinalAdvisorList);
                    _a.label = 8;
                case 8: return [3 /*break*/, 10];
                case 9:
                    error_3 = _a.sent();
                    console.error("Error fetching vehicle types:", error_3);
                    return [2 /*return*/, []];
                case 10: return [2 /*return*/];
            }
        });
    }); };
    var handleBranchClick = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var _event$target$value, _event$target, _event$target2, _event$target3;
        return __generator(this, function (_a) {
            setBranch((_event$target$value = event === null || event === void 0 || (_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.value) !== null && _event$target$value !== void 0 ? _event$target$value : "");
            setSelectedAdvisor('');
            if ((event === null || event === void 0 || (_event$target2 = event.target) === null || _event$target2 === void 0 ? void 0 : _event$target2.value) != "") {
                if (!(selectedValue == "My Appointments" || selectedValue == "My job card")) {
                    GetServiceAdvisor(event === null || event === void 0 || (_event$target3 = event.target) === null || _event$target3 === void 0 ? void 0 : _event$target3.value);
                }
            }
            else {
                setAdvisorListState([]);
            }
            return [2 /*return*/];
        });
    }); };
    var handleApplyFilter = function () {
        // dispatch(setIsFilterOpen(!commonState.isFilterOpen))
        if (startDocDate && endDocDate) {
            if (!(startDocDate !== null && startDocDate !== void 0 && startDocDate.isValid()) || !(endDocDate !== null && endDocDate !== void 0 && endDocDate.isValid())) {
                dispatch(showNotification({
                    isOpen: true,
                    message: "Please enter valid dates.",
                    type: "error"
                }));
                return;
            }
            if (startDocDate !== null && startDocDate !== void 0 && startDocDate.isAfter(endDocDate)) {
                dispatch(showNotification({
                    isOpen: true,
                    message: "From Date cannot be greater than To Date. Please enter valid dates.",
                    type: "error"
                }));
                return;
            }
            else if (!validateFilterDuration(startDocDate, endDocDate)) {
                var _MaxDateRange$Value;
                dispatch(showNotification({
                    isOpen: true,
                    message: "The maximum allowed duration for the filter is ".concat((_MaxDateRange$Value = MaxDateRange === null || MaxDateRange === void 0 ? void 0 : MaxDateRange.Value) !== null && _MaxDateRange$Value !== void 0 ? _MaxDateRange$Value : maxDays, " days."),
                    type: "error"
                }));
                return;
            }
        }
        setEndDateError(false);
        if (!isSmallScreen) {
            dispatch(setIsLeftMenuOpen(true));
        }
        var req = {
            Status: selectedStatus,
            ModelId: modelCode,
            ServiceAdvisorId: advisor,
            ServiceTypeId: selectedServiceType,
            BranchId: branch,
            StartDocDate: startDocDate ? startDocDate : "",
            EndDocDate: endDocDate ? endDocDate : ""
        };
        //setLocalStorageItem(FILTER_DATA, req)
        dispatch(setState({
            key: "filterValue",
            value: req
        }));
        if (handleOnClose) {
            handleOnClose();
        }
        dispatch(setState({
            key: "jobCardList",
            value: null
        }));
    };
    var setDate = function (startDate, endDate) {
        if (startDate) {
            setStartDocDate(dayjs(startDate));
        }
        if (endDate) {
            setEndDocDate(dayjs(endDate));
        }
    };
    var clearFilter = function () {
        setBranch('');
        setSelectedAdvisor('');
        setSelectedSeviceType('');
        setModelCode('');
        setEndDocDate(undefined);
        setStartDocDate(undefined);
        setSelectedStatus([]);
        setEndDateError(false);
        if (Object.keys(filterValue).length != 0) {
            dispatch(setState({
                key: "filterValue",
                value: {}
            }));
        }
        else { }
    };
    var onDateChange = function (e) {
        var _a = e.target, name = _a.name, value = _a.value;
        if (name === "endDate") {
            setEndDocDate(dayjs(value));
            setEndDateError(false);
        }
        else if (name === "startDate") {
            setStartDocDate(dayjs(value));
            setEndDocDate(undefined);
            setEndDateError(true);
        }
    };
    var getParentText = function () {
        switch (parent) {
            case EFilterParent["Appointment"]:
                return t("Appointment");
            case EFilterParent["Inspection"]:
                return t("Inspection");
            case EFilterParent["Final Inspection"]:
                return t("Final inspection");
            case "JobCard":
                return t("Job card");
            case EFilterParent["Estimate"]:
                return t("Estimate");
        }
    };
    var onStatusChange = function (e, value) {
        var updatedList = __spreadArray([], value, true);
        setSelectedStatus(updatedList);
        //   setSelectedStatus((val: any) => ({
        //     ...val,
        //     selectedStatus : value
        // }));
    };
    return /*#__PURE__*/ React.createElement(React.Fragment, null, loader.isLoaderOpen ? /*#__PURE__*/ React.createElement(Loader, null) : /*#__PURE__*/ React.createElement("div", {
        style: {
            height: '4px'
        }
    }), isSmallScreen ? /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "column"
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "column",
        padding: 3,
        spacing: 2,
        height: "100%"
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        width: '100%',
        justifyContent: 'space-between',
        alignItems: 'flex-start'
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "column"
    }, /*#__PURE__*/ React.createElement(Typography, {
        fontSize: "xxl",
        fontWeight: "strong"
    }, t("Filters")), /*#__PURE__*/ React.createElement(Typography, {
        fontSize: "base",
        fontWeight: "normal",
        color: 'secondary.500'
    }, t("Apply filters to table data."))), /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(MuiIconButton, {
        id: "closeFilterButton",
        onClick: function () {
            if (handleOnClose) {
                handleOnClose();
            }
        }
    }, /*#__PURE__*/ React.createElement("img", {
        id: "crossIcon",
        src: CrossIcon
    })))), /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "column",
        spacing: 2
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column'
    }, /*#__PURE__*/ React.createElement(Label, null, t("Branch")), /*#__PURE__*/ React.createElement(MuiSelectComponent, {
        id: "branchId",
        caption: t('BRANCH_SELECT_PLACEHOLDER'),
        fullWidth: true,
        options: branchList || [],
        displayExpr: "OrganizationName",
        valueExpr: "OrganizationId",
        name: "branch",
        value: branch !== null && branch !== void 0 ? branch : "",
        onChange: function (event) {
            handleBranchClick(event);
        }
    })), /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column'
    }, /*#__PURE__*/ React.createElement(Label, null, getParentText(), " ", t("status")), /*#__PURE__*/ React.createElement(Autocomplete, {
        fullWidth: true,
        multiple: true,
        disableCloseOnSelect: true,
        value: selectedStatus
        //limitTags={3}
        ,
        id: "multiple-contact-preference-dropdown",
        options: (filterList === null || filterList === void 0 ? void 0 : filterList.status) || [],
        getOptionLabel: function (option) { return option.Name; },
        onChange: onStatusChange,
        isOptionEqualToValue: function (option, value) {
            return option.Key === (value === null || value === void 0 ? void 0 : value.Key);
        },
        ListboxProps: {
            id: 'multiple-contact-preference-dropdown-item' // This is where you set the id for the list element
        },
        renderInput: function (params) { /*#__PURE__*/ return React.createElement(TextField, _extends({}, params, {
            placeholder: (selectedStatus === null || selectedStatus === void 0 ? void 0 : selectedStatus.length) == 0 ? "Select Status" : '',
            size: "small"
        })); },
        ChipProps: {
            shape: "rounded",
            variant: "outlined",
            size: 'small',
            deleteIcon: /*#__PURE__*/ React.createElement(Close, null)
        },
        size: "small"
    })), /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column'
    }, /*#__PURE__*/ React.createElement(Label, null, t("Service type")), /*#__PURE__*/ React.createElement(MuiSelectComponent, {
        id: "serviceTypeId"
        // labelSx={{ color: '#8593A3' }}
        //label={t("Select service type")}
        ,
        caption: t('SERVICE_TYPE_SELECT_PLACEHOLDER'),
        fullWidth: true,
        options: (filterList === null || filterList === void 0 ? void 0 : filterList.serviceType) || [],
        displayExpr: "Name",
        valueExpr: "id",
        name: "serviceType",
        value: selectedServiceType !== null && selectedServiceType !== void 0 ? selectedServiceType : "",
        onChange: function (event) {
            var _event$target$value2, _event$target4;
            setSelectedSeviceType((_event$target$value2 = event === null || event === void 0 || (_event$target4 = event.target) === null || _event$target4 === void 0 ? void 0 : _event$target4.value) !== null && _event$target$value2 !== void 0 ? _event$target$value2 : "");
        }
    })), /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column'
    }, /*#__PURE__*/ React.createElement(Label, null, t("Vehicle")), /*#__PURE__*/ React.createElement(MuiSelectComponent, {
        id: "vehicleId",
        caption: t('VEHICLE_SELECT_PLACEHOLDER'),
        fullWidth: true,
        options: (filterList === null || filterList === void 0 ? void 0 : filterList.vehicleList) || [],
        displayExpr: "vehicleName",
        valueExpr: "id",
        name: "Model",
        value: modelCode !== null && modelCode !== void 0 ? modelCode : '',
        onChange: function (event) {
            var _event$target$value3, _event$target5;
            setModelCode((_event$target$value3 = event === null || event === void 0 || (_event$target5 = event.target) === null || _event$target5 === void 0 ? void 0 : _event$target5.value) !== null && _event$target$value3 !== void 0 ? _event$target$value3 : "");
        }
    })), /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column'
    }, /*#__PURE__*/ React.createElement(Label, null, selectedDesignation.Name === "FinalInspector" ? t("Final inspector") : t("Service advisor")), selectedValue == (parent === "Appointment" ? "My Appointments" : parent === "JobCard" ? "My Job Card" : parent === "Inspection" ? "MY_INSPECTION" : parent === "Estimate" ? "My Estimate" : "") ? /*#__PURE__*/ React.createElement(MuiSelectComponent, {
        id: "serviceAdvisorId",
        displayConcat: true,
        caption: t("SERVICE_ADVISOR_SELECT_PLACEHOLDER"),
        fullWidth: true,
        options: serviceAdvisors,
        displayExpr: "advisorName",
        valueExpr: "IdentityId"
        // name="serviceadvisor"
        ,
        value: (_serviceAdvisors$ = serviceAdvisors[0]) === null || _serviceAdvisors$ === void 0 ? void 0 : _serviceAdvisors$.IdentityId,
        onChange: function (event) {
            var _event$target$value4, _event$target6;
            setSelectedAdvisor((_event$target$value4 = event === null || event === void 0 || (_event$target6 = event.target) === null || _event$target6 === void 0 ? void 0 : _event$target6.value) !== null && _event$target$value4 !== void 0 ? _event$target$value4 : "");
        },
        disabled: true
    }) : /*#__PURE__*/ React.createElement(MuiSelectComponent, {
        id: "serviceAdvisorId",
        displayConcat: true,
        caption: selectedDesignation.Name === "FinalInspector" ? "final inspector" : "service advisor",
        fullWidth: true,
        options: advisorListState || [],
        displayExpr: "advisorName",
        valueExpr: "IdentityId",
        name: "serviceadvisor",
        value: advisor !== null && advisor !== void 0 ? advisor : '',
        onChange: function (event) {
            var _event$target$value5, _event$target7;
            setSelectedAdvisor((_event$target$value5 = event === null || event === void 0 || (_event$target7 = event.target) === null || _event$target7 === void 0 ? void 0 : _event$target7.value) !== null && _event$target$value5 !== void 0 ? _event$target$value5 : "");
        },
        disabled: !branch
    })), /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        spacing: 0.25
    }, /*#__PURE__*/ React.createElement(Label, null, getParentText(), " ", t("date")), /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "column",
        alignItems: "flex-start"
    }, /*#__PURE__*/ React.createElement(MuiDatePicker, {
        id: "formDateId",
        label: "From date",
        onChange: onDateChange,
        value: startDocDate,
        name: "startDate",
        placeholder: t("From date")
    }), /*#__PURE__*/ React.createElement(MuiDatePicker, {
        id: "endDateId",
        label: "To date",
        name: "endDate",
        onChange: onDateChange
        // value={new Date(endDate)}
        ,
        value: endDocDate
        // value={endDate}
        // error={endDateError}
        ,
        placeholder: "".concat(t("To date"), " ").concat(endDateError ? '*' : ''),
        disabled: !startDocDate,
        maxDate: dayjs(startDocDate).add(MaxDateRange ? Number(MaxDateRange.Value) : maxDays, 'day'),
        minDate: startDocDate
    }))))), /*#__PURE__*/ React.createElement(MuiStack, {
        width: "100%",
        direction: 'column',
        spacing: 2,
        sx: {
            paddingBottom: '20px'
        }
    }, /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(Divider, {
        sx: {
            width: '100%'
        }
    })), /*#__PURE__*/ React.createElement(MuiStack, {
        paddingX: 2,
        justifyContent: 'flex-end'
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        width: '60%',
        spacing: 2
    }, /*#__PURE__*/ React.createElement(Button
    // style={{
    //   fontSize: '14px',
    //   fontWeight: 500,
    //   borderColor: '#DEE4EB'
    // }}
    , {
        color: "secondary",
        size: "medium",
        fullWidth: true,
        variant: "outlined",
        onClick: clearFilter,
        name: t('Reset'),
        id: "Reset",
        children: t('Reset')
    }), /*#__PURE__*/ React.createElement(Button
    // style={{
    //   fontSize: '14px',
    //   fontWeight: 500,
    // }}
    , {
        size: "medium",
        fullWidth: true,
        variant: "contained",
        id: "Apply",
        disabled: !(selectedStatus.length !== 0 || modelCode || advisor || selectedServiceType || branch || startDocDate || endDocDate) || endDateError,
        onClick: handleApplyFilter,
        children: t('Apply')
    }))))) : /*#__PURE__*/ React.createElement(MuiBox, {
        sx: {
            height: '100%',
            width: FilterComponentWidth,
            overflowY: 'auto'
        },
        className: "border-right-custom"
    }, /*#__PURE__*/ React.createElement(MuiBox, {
        sx: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: 1
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h3"
    }, t("Filters")), /*#__PURE__*/ React.createElement(ResetButton, {
        variant: "text",
        onClick: clearFilter,
        name: t("CLEAR ALL")
    })), /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "column"
    }, /*#__PURE__*/ React.createElement(MuiBox, {
        className: "border-bottom-custom",
        sx: {
            width: "100%"
        }
    }, /*#__PURE__*/ React.createElement(MuiAccordion, {
        onClick: function () { },
        title: "Mode",
        style: {
            width: "100%",
            boxShadow: "none"
        },
        titleVariant: "h5"
    }, /*#__PURE__*/ React.createElement(CheckboxFilters, {
        valueExpr: "MasterName",
        itemsList: (filterPickList === null || filterPickList === void 0 || (_filterPickList$data = filterPickList.data) === null || _filterPickList$data === void 0 ? void 0 : _filterPickList$data.Mode) || [],
        onChange: function (list) {
            setModes(list);
        },
        value: modes
    }))), /*#__PURE__*/ React.createElement(MuiBox, {
        className: "border-bottom-custom",
        sx: {
            width: "100%"
        }
    }, /*#__PURE__*/ React.createElement(MuiAccordion, {
        onClick: function () { },
        title: "Date",
        style: {
            width: "100%",
            boxShadow: "none"
        },
        titleVariant: "h5"
    }, /*#__PURE__*/ React.createElement(DateFilters, {
        EndDocDate: endDocDate,
        StartDocDate: startDocDate,
        handleDateChange: setDate
    }))), (commonState === null || commonState === void 0 || (_commonState$selected3 = commonState.selectedDesignation) === null || _commonState$selected3 === void 0 ? void 0 : _commonState$selected3.DesignationName) === "Service Advisor" && /*#__PURE__*/ React.createElement(MuiBox, {
        className: "border-bottom-custom",
        sx: {
            width: "100%"
        }
    }, /*#__PURE__*/ React.createElement(MuiAccordion, {
        onClick: function () { },
        title: "Status",
        style: {
            width: "100%",
            boxShadow: "none"
        },
        titleVariant: "h5"
    }, /*#__PURE__*/ React.createElement(CheckboxFilters, {
        valueExpr: "MasterName",
        itemsList: (filterPickList === null || filterPickList === void 0 || (_filterPickList$data2 = filterPickList.data) === null || _filterPickList$data2 === void 0 ? void 0 : _filterPickList$data2.Status) || [],
        onChange: function (list) {
            // setStatusList(list)
        }
        // value={statusList || []}
    }))), /*#__PURE__*/ React.createElement(MuiBox, {
        className: "border-bottom-custom",
        sx: {
            width: "100%"
        }
    }, /*#__PURE__*/ React.createElement(MuiAccordion, {
        onClick: function () { },
        title: "Service type",
        style: {
            width: "100%",
            boxShadow: "none"
        },
        titleVariant: "h5"
    }, /*#__PURE__*/ React.createElement(CheckboxFilters
    // value={repairType || []}
    // valueExpr="ServiceContractName"
    // itemsList={filterPickList?.data?.ServiceTypes || []}
    // onChange={(list: any) => {
    //     setRepairType(list)
    // }}
    , null))), /*#__PURE__*/ React.createElement(MuiBox, {
        sx: {
            width: "100%"
        }
    }, /*#__PURE__*/ React.createElement(MuiAccordion, {
        onClick: function () { },
        title: "Brand",
        style: {
            width: "100%",
            boxShadow: "none"
        },
        titleVariant: "h5"
    }, /*#__PURE__*/ React.createElement(CheckboxFilters, {
        valueExpr: "ModelName",
        itemsList: (filterPickList === null || filterPickList === void 0 || (_filterPickList$data3 = filterPickList.data) === null || _filterPickList$data3 === void 0 ? void 0 : _filterPickList$data3.Brand) || [],
        onChange: function (list) {
            setModelCode(list);
        },
        value: modelCode || []
    })))), /*#__PURE__*/ React.createElement(MuiStack, {
        width: "100%",
        p: 2
    }, /*#__PURE__*/ React.createElement(MuiButton, {
        fullWidth: true,
        onClick: handleApplyFilter,
        variant: "outlined",
        color: "secondary",
        name: t("APPLY FILTERS"),
        size: "medium"
    }))));
};
